import { FeatureFlags, useFeature } from '@melio/platform-feature-flags';
import { Features } from '@melio/subscriptions-api';
import { useContext } from 'react';

import { SubscriptionContext } from './context/SubscriptionContext';
import { SubscriptionContextType } from './context/types';

type UseIsFeatureInSubscriptionType = (featureKey: keyof Features) => { isInSubscription: boolean };

export const useIsFeatureInSubscription: UseIsFeatureInSubscriptionType = (featureKey) => {
  const [isPlatformSubscriptionsEnabled] = useFeature(FeatureFlags.PlatformSubscriptions, false);
  const {
    subscription,
    onboarding: { hasNoSubscription },
  } = useContext<SubscriptionContextType>(SubscriptionContext);

  if (!isPlatformSubscriptionsEnabled) {
    return { isInSubscription: true };
  }

  if (hasNoSubscription) {
    return { isInSubscription: false };
  }

  if (!subscription) {
    throw new Error('No subscription found. useIsFeatureInSubscription must be used within a SubscriptionProvider');
  }
  return { isInSubscription: !!subscription.features?.[featureKey]?.enabled };
};
